// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"style_titleBox__1EoK3","backdrop":"style_backdrop__3JUE9","tabpanel":"style_tabpanel__3DQu6","forgotPasswordButton":"style_forgotPasswordButton__2twtG"};